<template>
  <div class="car-segment">
    <div class="columns">
      <div class="column">
        <h5 class="is-size-5 has-text-black">{{ segment.carProvider.name }}</h5>

        <div class="is-size-7">
            Confirmation number:
          
          <span class="has-text-weight-bold">
            {{ segment.confirmationNumber }}</span>
          </div>

        <div class="columns mt-2 mb-0">
          <div class="column">
            <h5 class="is-size-6 mb-1">
              <div class="is-size-7">Pick-Up:</div>
              {{ segment.startDate.date | formatDate }} @
              {{ segment.startDate.time | formatTime }}
              <div class="has-text-grey is-size-7">{{
                segment.pickupLocation
              }}</div>
            </h5>
          </div>
          <div class="column">
            <h5 class="is-size-6 mb-2">
              <div class="is-size-7">Drop-Off:</div>
              {{ segment.endDate.date | formatDate }} @
              {{ segment.endDate.time | formatTime }}
              <div class="has-text-grey is-size-7">{{
                segment.dropoffLocation
              }}</div>
            </h5>
          </div>
        </div>
        <div class="has-text-grey mb-4 is-size-7">
          Trip Length: {{ segment.tripLength }} day(s), starting in
          {{ segment.daysUntilStart }} days
        </div>

        <div class="mb-4" v-if="segment.pricingInfo">
          Estimated Total:
          {{ segment.pricingInfo.total | formatPriceFromDollars(2) }}
          <span class="has-text-grey"
            >({{
              segment.pricingInfo.averagePricePerDay
                | formatPriceFromDollars(2)
            }}/day)</span
          >
        </div>

        <b-taglist>
          <b-tag v-for="(type, index) in segment.vehicleType" :key="index">
            {{ type }}
          </b-tag>
        </b-taglist>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarSegment",
  components: {},
  props: {
    segment: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
